import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/take';

import {
  ListItemModel
} from '../list/state';

import { SkyListFilterInlineModel } from '../list-filters/list-filter-inline.model';

import {
  SkyListViewChecklistComponent
} from '../list-view-checklist';

import {
  SkyModalInstance
} from '../modal';

import {
  SkyWindowRefService
} from '../window';

import {
  SkySelectField,
  SkySelectFieldSelectMode
} from './types';

import { SkySelectFieldPickerContext } from './select-field-picker-context';


export class SkySelectFieldPickerComponent implements OnInit, AfterContentInit {
  public categories: string[];
  public data: Observable<any>;
  public selectMode: SkySelectFieldSelectMode;
  public headingText: string;

  public readonly defaultCategory = 'any';
  public selectedCategory = this.defaultCategory;
  public selectedIds: any[] = [];

  
  private listViewChecklist: SkyListViewChecklistComponent;

  constructor(
    private context: SkySelectFieldPickerContext,
    private instance: SkyModalInstance,
    private elementRef: ElementRef,
    private windowRef: SkyWindowRefService
  ) { }

  public ngOnInit() {
    this.data = this.context.data;
    this.headingText = this.context.headingText;
    this.selectMode = this.context.selectMode;
    this.selectedIds = this.getSelectedIds();
    this.assignCategories();
  }

  public ngAfterContentInit() {
    this.windowRef.getWindow().setTimeout(() => {
      this.elementRef.nativeElement.querySelector('.sky-search-input').focus();
    });
  }

  public save() {
    this.latestData.subscribe((items: SkySelectField[]) => {
      const results = items.filter((item: SkySelectField) => {
        return (this.selectedIds.indexOf(item.id) > -1);
      });
      this.instance.save(results);
    });
  }

  public close() {
    this.instance.close();
  }

  public filterByCategory(model: ListItemModel, category: string) {
    return (category === this.defaultCategory || model.data.category === category);
  }

  public onCategoryChange(change: SkyListFilterInlineModel, filter: any) {
    // Reset the selected values when the category changes.
    this.listViewChecklist.clearSelections();
    filter.changed(change);
  }

  public onSelectedIdsChange(selectedMap: Map<string, boolean>) {
    this.latestData.subscribe((items: SkySelectField[]) => {
      this.selectedIds = items.filter(item => selectedMap.get(item.id))
        .map(item => item.id);
    });
  }

  private assignCategories() {
    this.latestData.subscribe((items: SkySelectField[]) => {
      const allCategories = items.map(item => item.category);
      // Remove duplicate category names:
      this.categories = allCategories.filter((category: string, i: number, categories: string[]) => {
        return (category && categories.indexOf(category) === i);
      });
    });
  }

  private get latestData(): Observable<SkySelectField[]> {
    return this.data.take(1);
  }

  private getSelectedIds(): string[] {
    const context = this.context;
    const selectedValue = context.selectedValue;

    if (selectedValue) {
      if (context.selectMode === 'single') {
        return [context.selectedValue.id];
      }

      return context.selectedValue.map((item: SkySelectField) => item.id);
    }

    return [];
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-select-field-picker',
  template: `<div class="sky-select-field-picker">
  <sky-modal>
    <sky-modal-header>
      {{ headingText }}
    </sky-modal-header>
    <sky-modal-content>
      <div class="sky-select-field-picker-content">
        <sky-list
          [data]="data"
          [selectedIds]="selectedIds"
          (selectedIdsChange)="onSelectedIdsChange($event)">
          <sky-list-toolbar>
            <sky-list-filter-inline
              *ngIf="categories && categories.length">
              <sky-list-filter-inline-item
                name="category"
                [defaultValue]="defaultCategory"
                [filter]="filterByCategory"
                [value]="defaultCategory">
                <ng-template
                  let-filter="filter">
                  <select
                    [ngModel]="filter.value"
                    (ngModelChange)="onCategoryChange($event, filter)">
                    <option
                      [value]="defaultCategory">
                      {{ 'select_field_picker_show_all_category' | skyResources }}
                    </option>
                    <option
                      *ngFor="let category of categories"
                      [value]="category">
                      {{ category }}
                    </option>
                  </select>
                </ng-template>
              </sky-list-filter-inline-item>
            </sky-list-filter-inline>
          </sky-list-toolbar>
          <sky-list-view-checklist
            label="label"
            description="description"
            [selectMode]="selectMode">
          </sky-list-view-checklist>
          <sky-list-paging
            pageSize="6">
          </sky-list-paging>
        </sky-list>
      </div>
    </sky-modal-content>
    <sky-modal-footer>
      <button
        type="button"
        class="sky-btn sky-btn-primary sky-select-field-picker-btn-save"
        (click)="save()">
        {{ 'select_field_picker_save_button' | skyResources }}
      </button>
      <button
        type="button"
        class="sky-btn sky-btn-link sky-select-field-picker-btn-close"
        (click)="close()">
        {{ 'select_field_picker_close_button' | skyResources }}
      </button>
    </sky-modal-footer>
  </sky-modal>
</div>
`,
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkySelectFieldPickerContext, },
{type: SkyModalInstance, },
{type: ElementRef, },
{type: SkyWindowRefService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'listViewChecklist': [{ type: ViewChild, args: [SkyListViewChecklistComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
